import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import FilterCloseIcon from "../../assets/filter-close.svg";
import FilterselectIcon from "../../assets/filter-blue.svg";
import { Dropdown, Button, Input } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

function DropdownFilterWithSearchInitialValue(props) {
  const { text, isSortable, value = "", onReset, onApply } = props;
  const shipmentName = sessionStorage.getItem("shipmentName");
  const [filters, setFilters] = useState(() => {
    let intialFilters = {
      text: "",
    };
    return {
      isOpen: false,
      isAsc: true,
      isFilterBoxOpen: null,
      filters: intialFilters,
    };
  });

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      filters: {
        text: value,
      },
    }));
  },[value]);

  let items = [];

  const sortableMenus = [
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("asc");
          }}
          className={
            filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort ascending
          <ArrowUpOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
    {
      label: (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleSort("desc");
          }}
          className={
            !filters.isAsc ? "ats-filter-sort sort-active" : "ats-filter-sort"
          }
        >
          Sort descending
          <ArrowDownOutlined />
        </button>
      ),
    },
    {
      type: "divider",
    },
  ];

  const menus = [
    {
      label: (
        <div>
          <span className="font-face-vzw ats-filter-header">Filter</span>
        </div>
      ),
    },
    {
      label: (
        <Input
          style={{
            width: "90%",
            height: "32px",
            marginTop: "5px",
            marginBottom: "5px",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "50px", // Circular edges
            paddingLeft: "40px", // Extra space to accommodate the icon
            display: "flex", // Use flexbox for horizontal alignment
            alignItems: "center", // Vertically center items
          }}
          name="name"
          value={filters.filters.text || JSON.parse(shipmentName)?.filters?.text || ""}
          className="form-control input-styles"
          type="search"
          placeholder="Search"
          onChange={(e) => {
            handleTextChange(e.target.value);
          }}
          prefix={
            <SearchOutlined style={{ position: "absolute", left: "10px" }} />
          }
        />
      ),
    },
    {
      label: (
        <div className="ats-filter-footer">
          <button onClick={handleReset} className="reset-filter">
            Reset filter
          </button>
          <Button
            onClick={handleApplyFilter}
            className="ats-filter-footer-button"
            color="default"
            variant="solid"
          >
            Apply
          </Button>
        </div>
      ),
    },
  ];

  if (isSortable) {
    items = [...sortableMenus, ...menus];
  } else {
    items = [...menus];
  }

  const handleSort = (val) => {
    if (val === "asc") {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: true }));
    } else {
      setFilters((prev) => ({ ...prev, isFilterBoxOpen: true, isAsc: false }));
    }
  };

  function handleReset(e) {
    e.preventDefault();
    setFilters((prev) => {
      let filters = {
        text: "",
      };

      return { ...prev, isAsc: true, filters: filters, isFilterBoxOpen: true, isOpen: false };
    });
    onReset({ filters: filters.filters, isAsc: filters.isAsc });
  }

  function handleApplyFilter(e) {
    e.preventDefault();
    setFilters((prev) => ({ ...prev, isFilterBoxOpen: false, isOpen: false }));
    onApply({ filters: filters.filters, isAsc: filters.isAsc });
  }

  const handleTextChange = (val) => {
    setFilters((prev) => ({
      ...prev,
      isFilterBoxOpen: true,
      filters: {
        ...prev.filters,
        text: val,
      },
    }));
  };

  const handleOpenChange = (val) => {
    if (val === false) {
      if (filters?.isOpen === true) {
        setFilters((prev) => ({ ...prev, isFilterBoxOpen: null, isOpen: val }));
      }
    } else {
      setFilters((prev) => ({ ...prev, isOpen: val }));
    }
  };

  function isAnyFilterTrue(data) {
    return data.text && data.text !== "";
  }

  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      open={filters.isOpen}
      overlayClassName="ats-filter-overlay"
    >
      <div className="ats-filter">
        <span className="font-face-vzw">{text}</span>
        <img
          src={
            filters.isOpen || isAnyFilterTrue(filters?.filters)|| shipmentName
              ? FilterselectIcon
              : FilterCloseIcon
          }
          alt="filter-icon"
        />
      </div>
    </Dropdown>
  );
}

DropdownFilterWithSearchInitialValue.propTypes = {
  text: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  value: PropTypes.string,
  onReset: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default DropdownFilterWithSearchInitialValue;
